export const BREAKPOINTSPX = {
    maxMobile: 390,
    maxIpad: 834
};

export const COMPENSATION_CODE = {
    WIFI: 'WIFI',
    NTP: 'NTP'
};

export const FIELD_NAMES = {
    bookingReference: 'bookingReference',
    comments: 'comments',
    compensationNum: 'compensationNum',
    compensationReason: 'compensationReason',
    compensationType: 'compensationType',
    confirmEmail: 'confirmEmail',
    date: 'date',
    email: 'email',
    firstName: 'firstName',
    flightNumber: 'flightNumber',
    lastName: 'lastName',
    ticketNumber: 'ticketNumber',
    wifiRegion: 'wifiRegion',
    categoryId: 'categoryId',
    reasonId: 'reasonId',
    cabinId: 'cabinId'
};

export const LANGUAGE = {
    en: 'en',
    fr: 'fr'
};

export const NEW_FORM_TYPE = {
    empty: 'empty',
    samePassenger: 'samePassenger'
};

export const NOTIFICATION_TYPE = {
    error: 'error',
    neutral: 'neutral',
    success: 'success',
    warning: 'warning'
};

export const REGEX = {
    alphaNumeric: /^[a-z0-9]+$/i,
    email: /^[^\s@.][^\s@]*@[^\s@]+\.[^\s@]+[^.\s@]$/,
    firstTwoCharsAreLetters: /^[a-zA-Z]{2}/,
    nonNumeric: /^[^0-9]*$/,
    numeric: /^\d+$/,
    removeNonAlphaNumeric: /[^0-9A-Za-z ]/gi
};

export const VALIDATION_TYPE = {
    alphaNumeric: 'alphaNumeric',
    nonNumeric: 'nonNumeric',
    numeric: 'numeric'
};

export const VIEW_TYPE = {
    ipad: 'ipad',
    mobile: 'mobile',
    web: 'web'
};

export const WIFI_REGION_MAPPING = {
    'North America, Central America & Caribbean': 'NA',
    'Amérique du Nord, Amérique centrale et Caraïbes': 'NA',
    'South America': 'SA',
    'Amérique du Sud': 'SA',
    'Africa, Europe & Middle East': 'TA',
    'Afrique, Europe et Moyen-Orient': 'TA',
    'Australia, Asia & India': 'TP',
    'Australie, Asie et Inde': 'TP'
};

export const HISTORY_VIEW = {
    ifs: 'ifs',
    nonIfs: 'nonIfs'
}

export const STORAGE_KEYS = {
    reasonMasterData: 'reasonMasterData'
};